import { getBrowserData, getOSName, getOSVersion } from "./index";
import { PlasmInternalError } from "../errrors/PlasmInternalError";
export class SentryUtils {
    static parseDSN(dsn) {
        const sentryDsnRegex = /^(?<protocol>\w+):\/\/(?<publicKey>\w+)(?::(?<secretKey>\w+))?@(?<host>[\w.-]+)(?<path>\/[\w/-]+)?\/(?<projectId>\w+)$/;
        const match = dsn.match(sentryDsnRegex);
        if (match == null) {
            throw new PlasmInternalError({ msg: "failed to parse sentry dsn" });
        }
        const { protocol, host, path, projectId, publicKey } = match.groups;
        const baseApiUrl = `${protocol}://${host}${path !== null && path !== void 0 ? path : ""}/api/${projectId}`;
        return { baseApiUrl, publicKey };
    }
    static buildSentryExceptionFromAppError(error, options = { isHandled: false }) {
        const type = error.name || "Error";
        const value = error.message || error.description || error.toString();
        const stackFrames = this.formatStackTraceForSentry(error);
        const stacktrace = stackFrames.length > 0 ? { frames: stackFrames } : undefined;
        const mechanism = { type: "generic", handled: options.isHandled };
        return { type, value, stacktrace, mechanism };
    }
    static formatStackTraceForSentry(error) {
        const stack = error.stack || "";
        const stackFrames = stack.split("\n").slice(1);
        const frames = stackFrames.map((frame) => {
            const match = frame.trim().match(/at\s+(.*?)\s+\((.*?):(\d+):(\d+)\)/);
            if (match) {
                const [, functionName, filename, lineno, colno] = match;
                return {
                    function: functionName,
                    filename,
                    lineno: parseInt(lineno, 10),
                    colno: parseInt(colno, 10),
                };
            }
            return {
                function: "",
                filename: frame,
                lineno: undefined,
                colno: undefined,
            };
        });
        return frames.reverse();
    }
    static buildExceptionContexts() {
        return {
            browser: getBrowserData(),
            os: {
                name: getOSName(),
                version: getOSVersion(),
            },
        };
    }
}
